export var DEFAULT_INITIAL_CHANNEL_PAGE_SIZE = 25;
export var DEFAULT_NEXT_CHANNEL_PAGE_SIZE = 100;
export var DEFAULT_JUMP_TO_PAGE_SIZE = 100;
export var DEFAULT_THREAD_PAGE_SIZE = 50;
export var DEFAULT_LOAD_PAGE_SCROLL_THRESHOLD = 250;
